import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface UpdateAllDocsSynopsisProps {
  issues: string;
}

export const useUpdateAllDocsSynopsis = (matterId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  const updateAllDocsSynopsis = async (data: UpdateAllDocsSynopsisProps) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.PATCH,
      data,
    });

    const response = await fetch(`${APIBaseChronos}/api/matters/${matterId}/update-all-docs-synopsis`, fetchConfig);
    if (!response.ok) {
      // Extract error message from backend response
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Error updating all docs synopsis');
    }
    return await response.json();
  };

  return useMutation({
    mutationFn: updateAllDocsSynopsis,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Subsets, { matterId }] });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.Matter, { matterId }] });
    },
    onError: (error: Error) => {
      console.error('Update all docs synopsis error:', error);
      toast.error(error.message || 'Failed to update synopsis. Please try again.');
    },
  });
};
